import Api from 'libs/api/index';

class ExtraSalesApi extends Api {
  constructor() {
    super('promo/extrasales/calendar/');
  }
}

export default ExtraSalesApi;
